import * as React from 'react'
import { FunctionComponent, ReactElement } from 'react'
import { Button } from '@ariakit/react'

interface SessionCardMobileButtonProps {
  text: string
  action?: () => void
  icon: ReactElement
  disabled?: boolean
}

const SessionCardMobileButton: FunctionComponent<
  SessionCardMobileButtonProps
> = ({ text, action = () => {}, icon, disabled = false }) => (
  <Button
    data-qa-name={`button-${text.split(' ')[0]}`}
    onClick={action}
    disabled={disabled}
    className='flex items-center leading-none rounded-md gap-2 p-3 text-sm font-body bg-indigo-50 hover:bg-indigo-100 cursor-pointer transition-colors
 text-indigo-800 border-none w-full'
  >
    {icon}
    {text}
  </Button>
)

export default SessionCardMobileButton
